import { useState, useEffect } from "react";
import { fetchCountries } from "../utils/countryUtils";

/**
 * Hook personnalisé pour la gestion des pays
 * @returns {Object} { countries, loading, error, refetch }
 */
export const useCountries = () => {
  const [countries, setCountries] = useState([
    { value: "TG", label: "Togo" }, // Pays par défaut
  ]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadCountries = async () => {
    try {
      setLoading(true);
      setError(null);
      const countriesData = await fetchCountries();
      setCountries(countriesData);
    } catch (err) {
      setError(err);
      console.error("Erreur lors du chargement des pays:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCountries();
  }, []);

  return {
    countries,
    loading,
    error,
    refetch: loadCountries,
  };
};
